import queryString from 'query-string';
import { camelizeKeys, decamelizeKeys } from 'humps';

export const buildQueryString = options =>
  camelizeKeys(
    queryString.stringify(decamelizeKeys(options), { arrayFormat: 'bracket' })
  );
